import React, { FC } from 'react';

import { classnames } from '@lumapps/classnames';
import { Size, Theme } from '@lumapps/lumx/react';
import { BaseVideo, CreatedByDetails } from '@lumapps/play/api/types';
import { UserBlock, UserBlockProps } from '@lumapps/user-ui/components/UserBlock';

import './index.scss';

export interface VideoPublisherProps extends UserBlockProps {
    className?: string;
    id?: BaseVideo['createdById'];
    theme?: Theme;
    user: CreatedByDetails;
}

const CLASSNAME = 'video-publisher';

export const VideoPublisher: FC<VideoPublisherProps> = ({ className, id, size, theme = 'light', user, ...props }) => (
    <UserBlock
        className={classnames(CLASSNAME, className)}
        user={{
            ...user,
            id,
        }}
        size={size || Size.s}
        theme={theme}
        {...props}
    />
);
